// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__158Wv","text":"SelectPayment_text__2pk1n","title":"SelectPayment_title__32If-","btn":"SelectPayment_btn__154zX"};